export default "__VITE_ASSET__D1hvHd1T__"